const sponsors = require('./data/Sponsors.json');

const SERVICE_PRIORITY = [
  'Microsoft Teams',
  'Microsoft Copilot (Microsoft 365)',
  'Microsoft Purview',
  'Dynamics 365 Apps',
  'Microsoft 365 apps',
  'Microsoft 365 suite',
  'SharePoint Online',
  'Microsoft 365 Copilot Chat',
  'Exchange Online',
  'Microsoft Viva',
  'Microsoft Entra',
  'Microsoft OneDrive',
  'Power Platform',
  'Microsoft Defender XDR',
  'Microsoft Copilot (Power Platform)',
  'Microsoft Power Automate',
  'Microsoft Dataverse',
  'Microsoft Intune',
  'Planner',
  'Power Apps',
  'Microsoft 365 for the web',
  'Power BI',
  'Microsoft Power Automate in Microsoft 365',
  'Microsoft Forms',
  'Microsoft Bookings',
  'Microsoft Clipchamp ',
  'Sway',
];

function isActiveSponsor(sponsor, at = new Date()) {
  const timestamp = at instanceof Date ? at.getTime() : new Date(at).getTime();
  const startsAt = new Date(sponsor.startsAt).getTime();
  const endsAt = new Date(sponsor.endsAt).getTime();

  return startsAt <= timestamp && timestamp < endsAt;
}

function selectSponsor(message, at = new Date(), bookings = sponsors) {
  const messageServices = new Set(message?.services ?? []);
  const activeByService = new Map(
    bookings
      .filter(sponsor => messageServices.has(sponsor.service) && isActiveSponsor(sponsor, at))
      .map(sponsor => [sponsor.service, sponsor])
  );

  const configuredMatch = SERVICE_PRIORITY.find(service => activeByService.has(service));
  if (configuredMatch) return activeByService.get(configuredMatch);

  return [...activeByService.values()].sort((a, b) => a.service.localeCompare(b.service))[0] ?? null;
}

function getServiceAvailability(at = new Date(), bookings = sponsors) {
  return SERVICE_PRIORITY.map(service => {
    const activeSponsor = bookings.find(
      sponsor => sponsor.service === service && isActiveSponsor(sponsor, at)
    );

    return {
      service,
      available: !activeSponsor,
      nextAvailableAt: activeSponsor?.endsAt ?? null,
    };
  });
}

module.exports = {
  SERVICE_PRIORITY,
  getServiceAvailability,
  isActiveSponsor,
  selectSponsor,
  sponsors,
};